import {
  Box,
  Button,
  Dialog,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import { styles } from "../styles/KidsLicenseModal.styles"
import { useTranslation } from "react-i18next"
import { useLicenceContext } from "../../../contexts/LicenceContext"
import FeatureItem from "../FeatureItem"
import LockIcon from "@mui/icons-material/Lock"
import AccessTimeIcon from "@mui/icons-material/AccessTime"
import { maxWidth600 } from "themes/default/breakpoints"

const smashyImg = require("assets/img/auth/smashy-01.gif")

const priceFormat = (price) => {
  if (!price) return ""
  return price.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export default function KidsLicenseModal({ open, onClose, licenceType }) {
  const { t } = useTranslation()
  const { orderData, openInvoice, productPrice, currencyCode } =
    useLicenceContext()
  const theme = useTheme()
  const mobile = useMediaQuery(maxWidth600)
  const titleText = t("license_payment_title_elementary_01") || ""
  const titleWords = titleText.trim().split(/\s+/)
  const firstWord = titleWords[0] || ""
  const remainingWords = titleWords.slice(1).join(" ")

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: styles.dialog,
      }}
    >
      <Box sx={styles.container}>
        <Box sx={styles.headerRow}>
          <Box sx={styles.headerLeft}>
            <Stack direction={"row"} alignItems={"center"} gap={1} mb={-1.5}>
              <Box sx={styles.ticketWrapper}>
                <Box
                  component="img"
                  src={require("assets/img/licenses/icono7.png")}
                  alt="ticket"
                  sx={styles.leftIcon}
                />
              </Box>
              <Typography component="h2" sx={styles.titleLine1}>
                {firstWord}
              </Typography>
            </Stack>
            <Typography component="h2" sx={styles.titleLine2}>
              {remainingWords}
            </Typography>
            <Typography sx={styles.subtitle}>
              {t("license_payment_title_elementary_02")}
            </Typography>
          </Box>
          <Box sx={styles.headerRight}>
            <Box sx={styles.bgCircle} />
            <Box
              component="img"
              src={smashyImg}
              alt="Smashy"
              sx={styles.mascot}
            />
          </Box>
        </Box>
        <Box sx={styles.sectionDividerRow}>
          <Box sx={styles.dividerLine} />
          <Typography sx={styles.sectionLabel}>
            {t("license_payment_section_elementary_01")}
          </Typography>
          <Box sx={styles.dividerLine} />
        </Box>
        <Stack
          sx={styles.featuresGrid}
          direction={mobile ? "column" : "row"}
          spacing={1}
        >
          <FeatureItem
            icon={require("assets/img/licenses/icono8.png")}
            title={t("license_payment_feature_title_elementary_01")}
            description={t("license_payment_feature_description_elementary_01")}
            iconBgColor={theme.palette.licenses.surface4}
            sx={{ flex: 1 }}
          />
          <FeatureItem
            icon={require("assets/img/licenses/icono9.png")}
            title={t("license_payment_feature_title_elementary_02")}
            description={t("license_payment_feature_description_elementary_02")}
            iconBgColor={theme.palette.licenses.surface5}
            sx={{ flex: 1 }}
          />
          <FeatureItem
            icon={require("assets/img/licenses/icono10.png")}
            title={t("license_payment_feature_title_elementary_03")}
            description={t("license_payment_feature_description_elementary_03")}
            iconBgColor={theme.palette.licenses.surface6}
            sx={{ flex: 1 }}
          />
        </Stack>
        <Box sx={styles.teacherBanner}>
          <Box sx={styles.bannerIconWrapper}>
            <LockIcon sx={styles.bannerIcon} />
          </Box>
          <Box sx={styles.bannerTextContent}>
            <Typography sx={styles.bannerTitle}>
              {t("license_payment_message_title_elementary_01")}
            </Typography>
            <Typography sx={styles.bannerDesc}>
              {t("license_payment_message_description_elementary_01")}
            </Typography>
          </Box>
        </Box>
        <Box sx={styles.actionsRow}>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Button
              variant="outlined"
              disableElevation
              onClick={onClose}
              startIcon={<AccessTimeIcon />}
              sx={styles.buttonCancel}
            >
              {t("maybe_later")}
            </Button>
            <Button
              variant="contained"
              disableElevation
              onClick={openInvoice}
              startIcon={
                <Box
                  component="img"
                  src={require("assets/img/licenses/icono12.png")}
                  alt="icon"
                  sx={styles.confirmIcon}
                />
              }
              sx={styles.buttonConfirm}
            >
              {`${t("license_payment_activate_button_elementary")} - ${
                orderData?.currency || currencyCode
              } ${priceFormat(orderData?.price || productPrice)}`}
            </Button>
          </Stack>
        </Box>
        <Box sx={styles.footerNote}>
          <LockIcon sx={styles.footerIcon} />
          <Typography sx={styles.footerText}>
            {t("secure_payment_powered_by_stripe")}{" "}
            {/* <Typography component="span" fontWeight={"bold"}>
              Stripe
            </Typography> */}
          </Typography>
        </Box>
      </Box>
    </Dialog>
  )
}
